import { useState } from 'react';

export function useCopyToClipboard(duration = 2000) {
  const [copiedId, setCopiedId] = useState<string | null>(null);

  const copyToClipboard = async (text: string, id: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), duration);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  const isCopied = (id: string) => copiedId === id;

  return { copyToClipboard, isCopied };
}
